var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNuvamaWealth = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.3838,
    height: 31,
    rx: 12.5,
    fill: "white",
    stroke: "#C59331"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6838 11C22.6838 12.857 21.1611 14.3619 19.2821 14.3619C17.4031 14.3619 15.8803 12.857 15.8803 11H13.0977C13.0977 14.3748 15.8673 17.112 19.2821 17.112C22.6968 17.112 25.4665 14.3748 25.4665 11H22.6838Z",
    fill: "#C59331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69672 21.5885C9.69672 19.7316 11.2195 18.2266 13.0985 18.2266C14.9775 18.2266 16.5002 19.7316 16.5002 21.5885H19.2829C19.2829 18.2138 16.5133 15.4766 13.0985 15.4766C9.68369 15.4744 6.91406 18.2116 6.91406 21.5885H9.69672Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNuvamaWealth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nuvamaWealth.53e51eca191da54d765215f4aa3f89ac.svg";